import FormField from './FormField';

export default class FormFieldCustom extends FormField
{

}
